module.exports = __webpack_public_path__ + "img/audit3.0c365470.png";